<template>
  <div class="Basket__item">
    <component
      :is="suitableComponent"
      :item="item.content"
      :detailed="detailed"
      :selected="selected"
      @update:selected="$emit('update:selected', $event)"
      @delete="$emit('delete')"
    ></component>
  </div>
</template>
<script>
import ProjectExportThumbnail from "./ProjectExportThumbnail";
import { ITEM_TYPES } from "../../store/mutations/basket";

const typeToComponent = {
  [ITEM_TYPES.PROJECT]: ProjectExportThumbnail
};

export default {
  name: "ExportItem",
  components: { ProjectExportThumbnail },
  props: {
    item: {},
    detailed: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    suitableComponent() {
      return typeToComponent[this.item.type];
    }
  }
};
</script>
